import { render, staticRenderFns } from "./Plan.vue?vue&type=template&id=cc30851a&scoped=true&"
import script from "./Plan.ts?vue&type=script&lang=ts&"
export * from "./Plan.ts?vue&type=script&lang=ts&"
import style0 from "./plan.scss?vue&type=style&index=0&id=cc30851a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc30851a",
  null
  
)

export default component.exports